import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { License } from "src/app/shared/models/license.model";

@Component({
	selector: "app-kitchen-device-list",
	templateUrl: "./kitchen-device-list.component.html",
	styleUrls: ["../../../../commandcenter.scss"],
})
export class KitchenDeviceListComponent implements OnInit {
	@Input() kitchenDeviceSelected: License;
	@Output() kitchenDeviceSelectedChange = new EventEmitter<License>();

	constructor(public app: AppService, private focuslink: FocuslinkService, public venueService: OOVenueService) {}

	ngOnInit(): void {
		this.venueService.subscriptionVenueKey.subscribe((data) => {
			if (data && data !== 0) {
				this.licenseGet(data);
			}
		});
	}

	async licenseGet(venueKey: number) {
		if (this.venueService.licenses.value.length === 0) {
			await this.venueService.licensesGet(venueKey);
		}
	}
}
